import React from 'react';
import { browserHistory, Link } from 'react-router';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import Form from '../../../../../../../../components/Form/Form/';
import Spinner from '../../../../../../../../components/Spinner';
import DateSelector from '../../../../components/DateSelector/';

import './Wrapper.scss';

const createJobMutation = gql`
mutation(
  $ComapnyID: Int!
  $Title: String!
  $Description: String
  $TimeStatus: String!
  $PayClass: String!
  $PayAmount: Int
  $StartDate: Int
  $EndDate: Int  
) {
  createJobOpening(CompanyID: $ComapnyID, input: {
    title: $Title
    description: $Description
    job_time_status: $TimeStatus
    pay_class: $PayClass
    pay_amount: $PayAmount
    start_date: $StartDate
    end_date: $EndDate
  }) {
    id
  }
}
`;

const userCompanyData = gql`
query {
  Companies: userCompany {
    id
  }
}
`;

class CreateForm extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      currentValues: {},
      error: null,
      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleCreateClick = this.handleCreateClick.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.displayError = this.displayError.bind(this);
  }

  componentDidMount () {
    if (this.props.authenticatedID === null) {
      browserHistory.push('/company');
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.authenticatedID === null) {
      browserHistory.push('/company');
    }

    if (nextProps.CompanyData.loading === false) {
      if (nextProps.CompanyData.Companies.length === 0) {
        browserHistory.push('/company/create');
      }
    }
  }

  validateForm (FormData) {
    let ErrorObject = {};
    const isValid = param => Object.prototype.hasOwnProperty.call(FormData, param) && FormData[param] !== '';

    if (isValid('job_time_status') === false) {
      ErrorObject['job_time_status'] = 'Job type is a required field';
    }

    if (isValid('title') === false) {
      ErrorObject['title'] = 'Position title is required';
    }

    if (isValid('description') === false) {
      ErrorObject['description'] = 'Position description is required';
    }

    if (isValid('pay_class') === false) {
      ErrorObject['pay_class'] = 'Please make a selection';
    }

    this.setState({
      error: ErrorObject,
    });

    return Object.keys(ErrorObject).length === 0;
  }

  displayError (field) {
    if (this.state.error !== null) {
      if (Object.prototype.hasOwnProperty.call(this.state.error, field)) {
        return (
          <p className='validationError'>
            {' - ' + this.state.error[field]}
          </p>
        );
      }
    }
    return null;
  }

  handleCreateClick () {
    // console.log(this.state.currentValues); return false;
    if (this.validateForm(this.state.currentValues)) {
      console.log(this.props.CompanyData);
      this.setState({
        loading: true,
      });

      this.props.createJob({
        variables: {
          ComapnyID: this.props.CompanyData.Companies[0].id,
          Title: this.state.currentValues.title,
          Description: this.state.currentValues.description,
          TimeStatus: this.state.currentValues.job_time_status,
          PayClass: this.state.currentValues.pay_class,
          PayAmount: this.state.currentValues.pay_amount,
          StartDate: this.state.currentValues.startDate,
          EndDate: this.state.currentValues.endDate,
        }
      }).then(jobData => {
        this.setState({
          loading: false,
        });
        browserHistory.push('/company/jobs');
      }).catch(err => {
        console.log(err);
        this.setState({
          loading: false,
          error: {
            general: err,
          }
        });
      });
    }
  }

  handleChange (event) {
    this.setState({
      currentValues: event.target.value,
    });

    console.log(event.target.value);
  }

  render () {
    if (this.props.authenticatedID !== null) {
      if (Object.prototype.hasOwnProperty.call(this.props.CompanyData, 'Companies')) {
        if (this.props.CompanyData.Companies.length > 0) {
          return (
            <div className='CreateJobForm__FromWrapper'>
              <div className='clearfix'>
                <h2 className='CreateJobForm__Title'>Create Job Position</h2>
                {this.displayError('general')}
              </div>
              <Form onChange={this.handleChange}>
                <div className='row CreateJobForm__FormSegment'>
                  <div className='col'>
                    <div className='clearfix'>
                      <h6>Job Type</h6>
                      {this.displayError('job_time_status')}
                    </div>
                    <select name='job_time_status' className='Form__Input'>
                      <option>Select Type</option>
                      <option value='part_time'>Part Time</option>
                      <option value='full_time'>Full Time</option>
                    </select>
                  </div>
                </div>
                <div className='row CreateJobForm__FormSegment'>
                  <div className='col'>
                    <div className='clearfix'>
                      <h6>Job Title</h6>
                      {this.displayError('title')}
                    </div>
                    <input className='Form__Input' type='text' name='title' />
                  </div>
                </div>
                <div className='row CreateJobForm__FormSegment'>
                  <div className='col'>
                    <div className='clearfix'>
                      <h6>Description</h6>
                      {this.displayError('description')}
                    </div>
                    <textarea className='Form__Input' rows={6} name='description' />
                  </div>
                </div>
                <div className='row CreateJobForm__FormSegment'>
                  <div className='col'>
                    <div className='clearfix'>
                      <h6>Payment</h6>
                      {this.displayError('pay_class')}
                    </div>
                    <select className='Form__Input' name='pay_class'>
                      <option value=''>Select one...</option>
                      <option value='unpaid'>Unpaid</option>
                      <option value='unknown_amount'>Mark as paid, but don't provide amount</option>
                      <option value='known_amount'>Paid. Provide amount.</option>
                    </select>
                    {(this.state.currentValues.pay_class === 'known_amount')
                        ? (<div>
                          <div>
                            <h6>Enter amount:</h6>
                            {this.displayError('pay_amount')}
                          </div>
                          <input type='text' className='Form__Input' name='pay_amount' />
                        </div>)
                        : ''}
                  </div>
                </div>
                <div className='row CreateJobForm__FormSegment'>
                  <div className='col-md'>
                    <div className='clearfix'>
                      <h6><span>Start Date</span><span className='CreateJobForm__Optionaltag'>(Optional)</span></h6>
                      {this.displayError('startDate')}
                    </div>
                    <DateSelector name='startDate' />
                  </div>
                  <div className='col-md'>
                    <div className='clearfix'>
                      <h6><span>End Date</span><span className='CreateJobForm__Optionaltag'>(Optional)</span></h6>
                      {this.displayError('endDate')}
                    </div>
                    <DateSelector name='endDate' />
                  </div>
                </div>
              </Form>
              <div className='clearfix'>
                <span onClick={this.handleCreateClick} className='Button__Submit'>
                  {(this.state.loading) ? <Spinner className='spinner--white' /> : 'Create Position'}
                </span>
                <Link to='/company/jobs' className='Button__Cancel'>Cancel</Link>
              </div>
            </div>
          );
        }
      }
    }
    return null;
  }
}

export default compose(
  graphql(createJobMutation, {
    name: 'createJob',
  }),
  graphql(userCompanyData, {
    name: 'CompanyData',
  })
)(CreateForm);



// WEBPACK FOOTER //
// ./src/routes/company/routes/Jobs/routes/Create/components/CreateForm/index.js